module.exports = __webpack_public_path__ + "img/project-1.d82ddba7.png";